import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { tap, switchMap, catchError, finalize } from 'rxjs/operators';
import { LoggerService } from '@shared/core/services/logger.service';
import { BaseApiService, IApiRequestOptions, TRequestMethod } from './base-api.service';
import { BaseCacheService } from '@shared/core/services/base-cache.service';
import { ProgressBarService } from '../../../cabinet/progress-bar/progress-bar.service';

@Injectable({
  providedIn: 'root',
})
export class AppApiService extends BaseApiService {
  constructor(
    protected http: HttpClient,
    protected cache: BaseCacheService,
    private logger: LoggerService,
    private progressBar: ProgressBarService,
  ) {
    super(http, cache);
  }

  request<T>(
    method: TRequestMethod,
    url: string,
    baseRequestOptions: IApiRequestOptions = { withCredentials: true },
  ): Observable<HttpResponse<T>> {
    return of(null).pipe(
      tap(() => {
        this.progressBar.show();
        // this.logger.info(`Api request: ${method} ${url}`);
      }),
      switchMap(() => super.request<T>(method, url, baseRequestOptions)),
      catchError(error => this.handleError(error)),
      finalize(() => this.progressBar.hide()),
    );
  }

  private handleError(error: HttpErrorResponse | never): Observable<never> {
    this.logger.error(`Api service:`, error);
    return throwError(error);
  }
}
